import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import CompanyLogo from "../../../common/CompanyLogo";
import ErrorMessage from "../../../common/errormsg/ErrorMessage";
import toast from "react-hot-toast";
import Api_Instance from "../../../api/Api_Instance";
import { Buysell } from "../../../api/endpoints";
import CountriesApi from "../../../common/countriesapi/CountriesApi";

function BuySell() {
  const api = Api_Instance.useApi();
  const intialValues = {
    name: "",
    email: "",
    phone: "",
    brand_name: "",
    country: "",
    state: "",
    city: "",
    buy_sell: "",
  }
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    brand_name: "",
    country: "",
    state: "",
    city: "",
    buy_sell: "",
  });
  const [errors, setErrors] = useState({});
  const [captchaToken, setCaptchaToken] = useState("");
  const [countrydata, setCountrydata] = useState({
    countryid: "",
    stateid: "",
    cityid: "",
  });
  const { useCountries, States, Ctiy } = CountriesApi;
  const { countries } = useCountries();
  const { statedata } = States(countrydata.countryid);
  const { citydata } = Ctiy(countrydata.stateid);

  const handleCountryChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selectedCountryName = options[selectedIndex].text;
    setFormValues((prevValues) => ({
      ...prevValues,
      country: value,
      state: "",
      city: ""
    }));
    setCountrydata((prev) => ({
      ...prev,
      countryid: selectedIndex - 1,
    }));
  };
  function formatField(field) {
    let formatted = field.replace(/_/g, " ");
    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
    return formatted;
  }

  const handleStateChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selected_id = options[selectedIndex].getAttribute("data-id");
    setFormValues((prevValues) => ({
      ...prevValues,
      state: value,
      city: ""
    }));
    setCountrydata((prev) => ({
      ...prev,
      stateid: selected_id,
    }));
  };
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const validationErrors = validate({
      ...formValues,
      [name]: value,
    });
    setErrors(validationErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const validationErrors = validate(formValues);
      setErrors(validationErrors);
      if (!captchaToken) {
        toast.error("Please verify the ReCAPTCHA.");
        return;
      }
      if (Object.keys(validationErrors).length === 0) {
        const res = await api("POST", Buysell.POST_BUYSELL, formValues);
        if (res.status) {
          toast.success(res.data.message || "Successfully Create");
          setFormValues(intialValues)
          // navigate("/");
        }
      }
    } catch (error) {
      if (error?.response?.data?.code === "token_not_valid") {
        toast.error("Session expired please login again");
      } else if (
        error?.response?.data?.detail ===
        "Authentication credentials were not provided."
      ) {
        toast.error("please login you are not authorized");
      } else {
        toast.error(error.message || "invalid data");
      }
    }
  };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emojiRegex =
    /([\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FA70}-\u{1FAFF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{2300}-\u{23FF}|\u{2B50}|\u{1F004}-\u{1F251}]+|\u{1F004}-\u{1F251}|\u{1F1E6}-\u{1F1FF})/gu;
  const validate = (values) => {
    const errors = {};
    const requiredFields = [
      "buy_sell",
      "name",
      "email",
      "phone",
      "brand_name",
      "country",
      "state",
      "city",
    ];

    requiredFields.forEach((field) => {
      const value = values[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        errors[field] =
          field === "buy_sell"
            ? "Buy & Sell is required"
            : `${formatField(field)} is required`;
      }
    });

    if (values.name) {
      if (!/^[A-Za-z\s]+$/.test(values.name)) {
      } else if (values.name.length < 2) {
        errors.name = "Name must be at least 2 characters";
      } else if (values.name.length > 20) {
        errors.name = "Name must be at most 20 characters";
      } else if (emojiRegex.test(values.name)) {
        errors.name = "Name should not contain emojis";
      }
    }
    if (values.email) {
      if (!emailRegex.test(values.email)) {
        errors.email = "Email address is invalid";
      }
      if (emojiRegex.test(values.email)) {
        errors.email = "Email should not contain emojis";
      }
    }

    const mobileNumberRegex = /^[6-9]\d{9}$/;
    if (values.phone) {
      if (!mobileNumberRegex.test(values.phone)) {
        errors.phone =
          "Mobile number must be exactly 10 digits long, start with 6, 7, 8, or 9, and contain no letters, special characters, or spaces.";
      } else if (emojiRegex.test(values.phone)) {
        errors.phone = "Mobile No should not contain emojis";
      }
    } else {
      errors.phone = "Mobile number is required.";
    }


    if (values.brand_name) {
      if (!/^[A-Za-z\s]+$/.test(values.brand_name)) {
        errors.brand_name = "Brand Name should only contain letters and spaces";
      } else if (values.brand_name.length > 150) {
        errors.brand_name = "Brand Name must be at most 150 characters";
      } else if (emojiRegex.test(values.brand_name)) {
        errors.brand_name = "Brand Name should not contain emojis";
      }
    }
    return errors;
  };
  return (
    <div>
      <CompanyLogo
        title={"Buy and Sell an Existing Business"}
        subtitle={" Buy and Sell an Existing Business"}
      />

      <div className="mt-5 w-full max-w-[1250px]     mx-auto 2xl:p-0 xl:p-0 lg:p-0 md:p-0 px-4">
        <p className="text-xl md:text-4xl font-semibold">
          Buy and Sell an Existing{" "}
          <span className="text-primaryColor">Business</span>
        </p>
        <hr className="mt-3" />
      </div>
      <div className="mt-5 w-full max-w-[1250px]     mx-auto 2xl:p-0 xl:p-0 lg:p-0 md:p-0 px-4">
        <div className="flex 2xl:flex-row xl:flex-row lg:flex-row md:flex-row flex-col justify-between items-start gap-5">
          <div className="w-full md:w-8/12 p-3 bg-card_bg_color border p-3 rounded-lg ">
            <p className="text-justify">
              The buying and selling of business go through meaningful phases.
              The dealing of the phases by each person is different. The focus
              of the buyer and the seller is different. The buyer and the seller
              both should be psyched-up for every phase to gain advantageously
              in the procedure.
            </p>
            <div className="flex flex-row items-start justify-start mt-4 space-y-2 md:space-y-0 md:space-x-2">
              <div className="w-6 md:w-12 flex justify-start mt-1">
                <img src="../../../../../img/checkicon.png" alt="Check Icon" />
              </div>
              <div className="flex-1">
                <p className="text-justify">
                  Readiness in business for sale - for the buyer, this aspect is
                  not self-evident as this is the first time, he will review the
                  business. He will target meeting mergers, and acquisition,
                  coming face to face with other business owners in the field.
                  The seller will focus on the conditions that cropped up and
                  caused weakness to business and will lead to value downsizing.
                  A planning time will be needed to upgrade the vulnerability so
                  a good price for the business is gained.
                </p>
              </div>
            </div>
            <div className="flex flex-row items-start justify-start mt-4 space-y-2 md:space-y-0 md:space-x-2">
              <div className="w-6 md:w-12 flex justify-start mt-1">
                <img src="../../../../../img/checkicon.png" alt="Check Icon" />
              </div>
              <div className="flex-1">
                <p className="text-justify">
                  Purchaser list- the buyer is required to develop the
                  investment yardstick and the business mergers and acquisition
                  advisors will ponder over it. The protocol will be based on
                  revenue, gain before interest, taxes, depreciation as well as
                  amortization. The industry and location are also important. As
                  regards the seller the investment banker works on the
                  potential buyer list for the company. The seller is also
                  required to contemplate from among the list the best for the
                  company. This includes competitors, clients, vendors, and
                  other allied companies.
                </p>
              </div>
            </div>
            <div className="flex flex-row items-start justify-start mt-4 space-y-2 md:space-y-0 md:space-x-2">
              <div className="w-6 md:w-12 flex justify-start mt-1">
                <img src="../../../../../img/checkicon.png" alt="Check Icon" />
              </div>
              <div className="flex-1">
                <p className="text-justify">
                  Letter of intent-this is the commencing agreement between the
                  buyer and the seller. The letter projects circumstances of the
                  transaction and are mostly not confining. The buyers' approach
                  is general which has a certain amount of flexibility to again
                  mediate the purchase agreement in case unfavourable
                  information is discovered in the period of diligence phase.
                  The seller's fixation is to discard any of the buyer's vague
                  communication or terminology that are open to
                  misinterpretation. Transparency in terms and conditions
                  curtail disagreements and renegotiation and purchase agreement
                  is prepared with ease. The bargaining deviates from seller to
                  buyer once the letter of intent is signed.
                </p>
              </div>
            </div>
            <div className="mt-5 px-4 md:px-0">
              <p className="text-justify">
                Purchasing an existing business is less uncertain compared to
                beginning from a scratch. The seller should purchase business,
                which is profit-generating, an established customer base, a name
                in the market, and manpower well-versed in the art of business.
                The seller has already established the procedures, systems, and
                policies. The buyer need not reinvent the wheel.
              </p>
            </div>
          </div>

          <div className="w-full md:w-5/12 bg-card_bg_color border 2xl:p-3 xl:p-3 lg:p-3 md:p-3 p-0 rounded-lg">
            <form className="space-y-2" onSubmit={handleSubmit}>
              <div className="flex flex-col items-center">
                <div className="w-full">
                  <div className="p-3 flex flex-row gap-4 md:gap-10">
                    <label className="flex items-center space-x-3">
                      <input
                        type="radio"
                        name="buy_sell"
                        value={"buy"}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        className="form-radio h-4 w-4 text-blue-600"
                      />
                      <span className="text-gray-700">Buy Business</span>
                    </label>
                    <label className="flex items-center space-x-3 md:mt-0">
                      <input
                        type="radio"
                        name="buy_sell"
                        value={"sell"}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        className="form-radio h-4 w-4 text-blue-600 "
                      />
                      <span className="text-gray-700">Sell Business</span>
                    </label>
                  </div>
                  <p className="mx-3">
                    {errors.buy_sell && <ErrorMessage error={errors.buy_sell} />}
                  </p>
                </div>
                <div className="w-full p-3">
                  <label className="mb-2 font-md block font-semibold capitalize">Name</label>
                  <div className="">
                    {/* <FontAwesomeIcon
                      icon={faUser}
                      className="input-icon absolute left-[20px] bg-white top-[40%] bottom-0"
                    /> */}
                    <input
                      type="text"
                      id="name"
                      placeholder="Enter Name"
                      name="name"
                      value={formValues.name}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      className="border border-[#D9D9D9] rounded-md mt-1 block p-2 w-full "
                    />

                  </div>
                  <p className="">
                    {errors.name && <ErrorMessage error={errors.name} />}
                  </p>

                </div>
                <div className="w-full">
                  <div className="mx-3 mb-3">
                    <label className="mb-2 font-md block font-semibold capitalize">Email</label>
                    {/* <FontAwesomeIcon
                      icon={faEnvelope}
                      className="input-icon absolute left-[30px] bg-white top-[40%] bottom-0"
                    /> */}
                    <input
                      type="email"
                      id="email"
                      placeholder="Enter Email"
                      name="email"
                      value={formValues.email}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      className="border border-[#D9D9D9] rounded-md mt-1 block py-2 w-full"
                    />
                    <p className="">
                      {errors.email && <ErrorMessage error={errors.email} />}
                    </p>
                  </div>

                </div>
                <div className="w-full">
                  <div className="mx-3 mb-3">
                    <label className="mb-2 font-md block font-semibold capitalize">Mobile</label>
                    {/* <FontAwesomeIcon
                      icon={faMobile}
                      className="input-icon absolute left-[30px] bg-white top-[43%] bottom-0"
                    /> */}
                    <input
                      type="mobile"
                      id="mobile"
                      placeholder="Enter Mobile"
                      name="phone"
                      value={formValues.phone}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      className="border border-[#D9D9D9] rounded-md mt-1 block p-2  w-full"
                    />
                    <p className="">
                      {errors.phone && <ErrorMessage error={errors.phone} />}
                    </p>
                  </div>

                </div>
                <div className="w-full">
                  <div className="mx-3 mb-3">
                    <label className="mb-2 font-md block font-semibold capitalize">Brand Name</label>
                    {/* <FontAwesomeIcon
                      icon={faUser}
                      className="input-icon absolute left-[30px] bg-white top-[40%] bottom-0"
                    /> */}
                    <input
                      type="text"
                      id="InvestmentRange"
                      placeholder="Brand name"
                      name="brand_name"
                      value={formValues.brand_name}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      className="border border-[#D9D9D9] rounded-md mt-1 block p-2 w-full"
                    />
                    <p className="">
                      {errors.brand_name && (
                        <ErrorMessage error={errors.brand_name} />
                      )}
                    </p>
                  </div>

                </div>
                <div className="w-full">
                  <div className="mx-3">
                    <label className="mb-2 font-md block font-semibold capitalize">Select Country</label>
                    <div className="">
                      <select
                        id="country"
                        name="country"
                        value={formValues.country}
                        onChange={handleCountryChange}
                        onBlur={handleBlur}
                        class="border rounded-md mt-1 w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="" disabled>
                          Country
                        </option>
                        {countries?.map((item) => (
                          <option value={item.name}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    <p className="">
                      {errors.country && <ErrorMessage error={errors.country} />}
                    </p>
                  </div>
                </div>
                <div className="w-full p-3">
                <label className="mb-2 font-md block font-semibold capitalize">Select state</label>
                  <select
                    id="state"
                    name="state"
                    value={formValues.state}
                    onChange={handleStateChange}
                    onBlur={handleBlur}
                    class="border  rounded-md mt-1 w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  >
                    <option value="" disabled>
                      State
                    </option>
                    {statedata?.map((item) => (
                      <option value={item.name} data-id={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>

                  {errors.state && <ErrorMessage error={errors.state} />}
                </div>
                <div className="w-full p-3">
                <label className="mb-2 font-md block font-semibold capitalize">Select City</label>
                  <select
                    id="city"
                    name="city"
                    value={formValues.city}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    class="border  rounded-md mt-1 w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  >
                    <option value="" disabled>
                      city
                    </option>
                    {citydata?.map((item) => (
                      <option value={item.name}>{item.name}</option>
                    ))}
                  </select>
                  {errors.city && <ErrorMessage error={errors.city} />}
                </div>

                <div className="w-full flex items-center mt-3 p-3">
                  {/* <input
                    type="checkbox"
                    id="captcha"
                    className="form-checkbox h-5 w-5 text-blue-600 rounded"
                  /> */}
                  <label
                    htmlFor="captcha"
                    className="ml-2 flex items-center text-gray-700 text-sm cursor-pointer"
                  >
                    <ReCAPTCHA
                    sitekey="6Ld_Ip4qAAAAAFzyb5JeIfCdiZxdUVNgOGB-lJr1" // Your public site key
                    onChange={(token) => setCaptchaToken(token)}
                  />
                  </label>
                </div>
              </div>
              <div className="xl:p-0 lg:p-0 md:p-0 px-4">
                <button
                  type="submit"
                  className="xl:m-0 lg:m-0 md:m-0 m-3 w-full md:w-1/3 mx-auto py-2 px-4 border border-transparent rounded-lg shadow-sm text-center font-medium text-white bg-primaryColor cursor-pointer [transition:all_.15s_ease-in-out] hover:[box-shadow:0_0_10px_0_#0098c6_inset,_0_0_20px_2px_#0096c48c]"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BuySell;
